import { Component, OnInit } from '@angular/core';
import { IAircraftModel } from './aircraft-models.types';
import { AircraftModelsService } from './aircraft-models.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';

@Component({
	selector: 'app-aircraft-models',
	templateUrl: './aircraft-models.component.html',
	styleUrls: ['./aircraft-models.component.scss']
})
export class AircraftModelsComponent implements OnInit {
	constructor(private aircraftModelsService: AircraftModelsService, private router: Router) {}

	public aircraftModels: IAircraftModel[];
	public onlyArchived: boolean;

	ngOnInit(): void {
		this.getAircraftModels();
	}

	public getAircraftModels(): void {
		this.aircraftModels = [];
		this.aircraftModelsService.getAircraftModels().subscribe(
			(DATA: IAircraftModel[]) => {
				if (DATA) {
					this.aircraftModels = DATA;
				}
			},
			(error: HttpErrorResponse) => {
				console.error(error);
			}
		);
	}

	public navigate(id: string): void {
		this.router.navigate(['/pilotpay/aircraft-models/details', id]);
	}

	public changeFilter(): void {
		if (this.onlyArchived) {
			this.getArchivedAircraftModels();
		} else {
			this.getAircraftModels();
		}
	}

	public getArchivedAircraftModels(): void {
		this.aircraftModels = [];
		this.aircraftModelsService.getArchivedAircraftModels().subscribe(
			(DATA: IAircraftModel[]) => {
				if (DATA) {
					this.aircraftModels = DATA;
				}
			},
			(error: HttpErrorResponse) => {
				console.error(error);
			}
		);
	}
}
